module.exports = {"420111001":"珞南街道","420111002":"关山街道","420111003":"狮子山街道","420111004":"张家湾街道","420111005":"梨园街道","420111006":"卓刀泉街道","420111007":"洪山街道","420111008":"和平街道","420111009":"青菱街道","420111061":"八吉府街","420111080":"关东街道","420111081":"花山街道","420111082":"左岭街道","420111083":"九峰街道","420111205":"天兴乡","420111460":"清谭湖","420111491":"东湖风景区街道（洪山）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420111.json
// module id = 1555
// module chunks = 0